import { EMPLOYEE_COMPETENCY_LEVEL } from 'domain/shared/performanceMeasurement';
import { POSITION_SLOT_STATUS } from 'domain/people/positionSlots/constants';

export const WORKFORCE_ANALYTICS_PATH = '/workforce-analytics';

export const WORKFORCE_ANALYTICS_POSITION_SLOT_PAGE_SIZE = 1000;
export const WORKFORCE_ANALYTICS_INCLUDED_POSITION_SLOT_STATUSES = [
  POSITION_SLOT_STATUS.OPEN,
  POSITION_SLOT_STATUS.FILLED,
];

export enum WorkforceAnalyticsViewBy {
  POSITION = 'POSITION',
  BUSINESS_FUNCTION = 'BUSINESS_FUNCTION',
}

export enum WorkforceAnalyticsColumn {
  TOTAL = 'TOTAL',
  L0 = 'L0',
  L1 = 'L1',
  L2 = 'L2',
  L3 = 'L3',
  L4 = 'L4',
  L5 = 'L5',
  L6 = 'L6',
}

export const WORKFORCE_ANALYTICS_TOTAL_COLUMN = WorkforceAnalyticsColumn.TOTAL;

export const WORKFORCE_ANALYTICS_LEVEL_COLUMNS = [
  WorkforceAnalyticsColumn.L0,
  WorkforceAnalyticsColumn.L1,
  WorkforceAnalyticsColumn.L2,
  WorkforceAnalyticsColumn.L3,
  WorkforceAnalyticsColumn.L4,
  WorkforceAnalyticsColumn.L5,
  WorkforceAnalyticsColumn.L6,
];

export const WORKFORCE_ANALYTICS_COLUMNS: WorkforceAnalyticsColumn[] = [
  WORKFORCE_ANALYTICS_TOTAL_COLUMN,
  ...WORKFORCE_ANALYTICS_LEVEL_COLUMNS,
];

export const WORKFORCE_ANALYTICS_VIEW_BY_LABELS: Dictionary<string> = {
  [WorkforceAnalyticsViewBy.POSITION]: 'Position',
  [WorkforceAnalyticsViewBy.BUSINESS_FUNCTION]: 'Business function',
};

export const WORKFORCE_ANALYTICS_COLUMN_LABELS: Dictionary<string> = {
  [WORKFORCE_ANALYTICS_TOTAL_COLUMN]: 'Total',
  [EMPLOYEE_COMPETENCY_LEVEL.L0]: 'L0',
  [EMPLOYEE_COMPETENCY_LEVEL.L1]: 'L1',
  [EMPLOYEE_COMPETENCY_LEVEL.L2]: 'L2',
  [EMPLOYEE_COMPETENCY_LEVEL.L3]: 'L3',
  [EMPLOYEE_COMPETENCY_LEVEL.L4]: 'L4',
  [EMPLOYEE_COMPETENCY_LEVEL.L5]: 'L5',
  [EMPLOYEE_COMPETENCY_LEVEL.L6]: 'L6',
};

export const WORKFORCE_ANALYTICS_SUMMARY_ROW_LABELS: Dictionary<string> = {
  [WorkforceAnalyticsViewBy.POSITION]: 'All positions',
  [WorkforceAnalyticsViewBy.BUSINESS_FUNCTION]: 'All business functions',
};

export const WORKFORCE_ANALYTICS_HIGH_FILL_RATE = 95;
